import { render, staticRenderFns } from "./ProductColumnEditDialog.vue?vue&type=template&id=b4dfc7b4&scoped=true"
import script from "./ProductColumnEditDialog.vue?vue&type=script&lang=js"
export * from "./ProductColumnEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductColumnEditDialog.vue?vue&type=style&index=0&id=b4dfc7b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dfc7b4",
  null
  
)

export default component.exports